import { useSanity } from './useSanity';
import type { SupportContacts } from '../types/support';

export type SupportContent = {
  title?: string;
  callToActionURL?: string;
};

export const getSupportContacts = (content: SupportContent[] = []): SupportContacts | undefined => {
  const contacts: SupportContacts = {};

  for (const entry of content) {
    if (!entry.callToActionURL) {
      continue;
    }

    try {
      const url = new URL(entry.callToActionURL);
      if (url.protocol !== 'https:' || url.username || url.password) {
        continue;
      }

      const destination = url.pathname.slice(1);
      if (url.hostname === 'wa.me' && /^\d+$/.test(destination) && !contacts.whatsapp) {
        contacts.whatsapp = {
          url: url.href,
          displayText: typeof entry.title === 'string' && entry.title ? entry.title : `+${destination}`,
        };
      }
      if (url.hostname === 't.me' && /^[a-zA-Z0-9_]+$/.test(destination) && !contacts.telegram) {
        contacts.telegram = { url: url.href, displayText: '' };
      }
    } catch {
      // Other support entries can be internal content or have no valid external URL.
    }
  }

  return contacts.whatsapp || contacts.telegram ? contacts : undefined;
};

const useSupportContacts = () => {
  const { data } = useSanity<SupportContent>('FooterSupportContent');

  return getSupportContacts(data);
};

export default useSupportContacts;
